import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["backgroundColor", "size", "color", "children", "isRound"];
import React from "react";
import PropTypes from "prop-types";
import * as constants from "@paprika/constants/lib/Constants";
import * as sc from "./Avatar.styles";

function Avatar(props) {
  var backgroundColor = props.backgroundColor,
      size = props.size,
      color = props.color,
      children = props.children,
      isRound = props.isRound,
      moreProps = _objectWithoutProperties(props, _excluded);

  if (!isRound && size === Avatar.types.size.SMALL) {
    console.warn("In @paprika/".concat(Avatar.displayName, " component, the size=\"SMALL\" should only be used when isRound={true}"));
  }

  var isChildString = typeof children === "string";
  return /*#__PURE__*/React.createElement(sc.Avatar, _extends({
    "data-pka-anchor": "avatar",
    $backgroundColor: backgroundColor,
    $color: color,
    size: size,
    isChildString: isChildString,
    isRound: isRound
  }, moreProps), children);
}

Avatar.types = {
  size: constants.defaultSize
};
var propTypes = {
  /** Avatar content. It can be initial as a string or icon */
  children: PropTypes.node,

  /** Background color of the Avatar */
  backgroundColor: PropTypes.string,

  /** Color for the initial or icon */
  color: PropTypes.string,

  /** Shape of the Avatar */
  isRound: PropTypes.bool,

  /** Size of Avatar */
  size: PropTypes.oneOf([Avatar.types.size.SMALL, // for use with isRound only
  Avatar.types.size.MEDIUM, Avatar.types.size.LARGE])
};
var defaultProps = {
  backgroundColor: null,
  children: null,
  color: null,
  isRound: false,
  size: Avatar.types.size.LARGE
};
Avatar.displayName = "Avatar";
Avatar.propTypes = propTypes;
Avatar.defaultProps = defaultProps;
export default Avatar;
//# sourceMappingURL=Avatar.js.map